import { isFeatureEnabled } from '../../../../../common/users/utils/userPropertyUtils';
import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';
import { isOriginalUploadTransparent } from '../../../../element/image/modal/backgroundRemoval/imageModalBackgroundRemovalUtils';

import type { AvailabilityPredicateArgs } from '../../toolbarTypes';

type ImageBackgroundToolAvailabilityArgs = Pick<AvailabilityPredicateArgs, 'selectedElements' | 'currentUser'>;

export const isImageBackgroundToolAvailable = ({
    selectedElements,
    currentUser,
}: ImageBackgroundToolAvailabilityArgs): boolean => {
    const selectedElement = selectedElements.first();

    return (
        !!selectedElement &&
        // The tool opens the V2 modal in background mode, so it needs both the modal and the
        // separately released background removal feature.
        isFeatureEnabled(ExperimentId.imageModalV2, currentUser) &&
        isFeatureEnabled(ExperimentId.imageBackgroundRemoval, currentUser) &&
        !isOriginalUploadTransparent(selectedElement)
    );
};
